/* eslint-disable no-unused-vars */
import CampaignBase from '../CampaignBase';

// 不显示折扣标签的套餐id
const disable_commodity = [2492, 2493, 2494];

// 不显示折扣标签的产品id
const disable_product = [19, 24, 13, 22, 18];

class HideLimitedOffer extends CampaignBase {
  constructor(props) {
    super(props);
  }
  // 产品页是否展示
  enableProductPage = (productInfo = {}, from = 'page') => {
    switch (from) {
      case 'tag':
        return true;
      default:
        return false;
    }
  };

  hideLimitedOffer = (cid, pid) => {
    if (disable_commodity.includes(cid)) return false;
    if (disable_product.includes(pid)) return false;
    return true;
  };

  /**
   * 获取套餐标签，删掉limitOffer
   * @param {*} commodity
   * @param {*} currentLabels
   * @param {*} LANG
   * @returns {import('../type').cmdLabel}
   */
  getCommodityLabel = (commodity, currentLabels, LANG) => {
    if (this.hideLimitedOffer(commodity.id, commodity.product)) {
      return null;
    }
    return {
      replaceLabels: currentLabels.filter((d) => d?.tagName !== 'limitedOffer'),
    };
  };
}

export default HideLimitedOffer;
